<template>
  <b-button
    block
    href="#"
    variant="custom"
    class="item__button"
    @click.prevent="onClick">
    <v-icon scale="1.8"
      :name="icon"
      class="icons" />
    {{ label }}
  </b-button>

</template>

<script>
import { BButton } from 'bootstrap-vue/es/components'

export default {
  name: 'BarraLateralBotao',
  components: {
    BButton,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
  },
  methods: {
    onClick() {
      this.$emit('onClick')
    },
  },
}

</script>

<style lang="scss" scoped>
@import "@/scss/colors.scss";

.item {
  width: 100%;

  &__button {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-start;
    padding: .4rem 0;

    text-align: start;
    color: $cor-fonte-escura;
  }
}

.icons {
  width: 2.5rem;
}

</style>
